import { render } from "./bubble_timeline.vue?vue&type=template&id=b010a180"
import script from "./bubble_timeline.js?vue&type=script&lang=js"
export * from "./bubble_timeline.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__